import { Dialog, DialogContent, DialogTitle, Stack, Typography } from '@mui/material';
import { CookieErrors } from 'enums';
import { useUserData } from 'hooks/use-user-data';
import _ from 'lodash';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { makeStyles } from 'tss-react/mui';
import { CookieError } from 'types/cookies.types';
import PaiButton from '../../ui/base-components/pai-button';

interface Props {
  open: boolean;
  error?: CookieError;

  handleClose(): void;
}

const CookieDialog: React.FC<Props> = ({ open, error, handleClose }) => {
  const { classes } = useStyles();
  const { t } = useTranslation();
  const { firstName } = useUserData();

  const generateHourLimitContent = () => {
    const storedAnalyses = localStorage.getItem('linkedin-analysis');
    const analysisArray: { startedAt: string; dailyLimit: number; liAt: string }[] = storedAnalyses ? JSON.parse(storedAnalyses) : [];
    const findAnalysis = analysisArray.find((analysis) => analysis.liAt === error?.cookie);

    const storedLimit = findAnalysis?.dailyLimit;

    if (!_.isNil(storedLimit)) {
      return t('cookieDailyLimitReachedContent', { count: storedLimit });
    }
    return '';
  };

  return (
    <Dialog open={open} classes={{ paper: classes.paper }} fullWidth={true} maxWidth={'xs'}>
      <DialogTitle className={classes.title}>
        <Typography className={classes.titleText}>{t('cookieErrorTitle')}</Typography>
      </DialogTitle>
      <DialogContent className={classes.content}>
        <Stack gap={2}>
          <Typography className={classes.subTitle}>{t('cookieDialogTitle', { firstName })}</Typography>
          {error?.message === CookieErrors.HOUR_LIMIT ? (
            <Typography className={classes.info} dangerouslySetInnerHTML={{ __html: generateHourLimitContent() }} />
          ) : (
            <Typography className={classes.info}>{t('generalCookieError')}</Typography>
          )}
        </Stack>
      </DialogContent>
      <div className={classes.actions}>
        <PaiButton text={t('ok')} action={handleClose} />
      </div>
    </Dialog>
  );
};

const useStyles = makeStyles()((theme) => ({
  paper: {
    borderRadius: 0,
  },
  title: {
    background: theme.palette.warning.main,
  },
  titleText: {
    fontSize: theme.typography.pxToRem(15),
    fontWeight: 'bold',
    textTransform: 'uppercase',
    color: '#FFF',
    textAlign: 'center',
  },
  content: {
    padding: '24px !important',
  },
  subTitle: {
    fontSize: theme.typography.pxToRem(15),
  },
  actions: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    gap: '16px',
    padding: '0 24px 24px 24px',
  },
  info: {
    fontSize: theme.typography.pxToRem(15),
    color: theme.palette.primary.main,
    fontWeight: 'bold',
  },
}));

export default CookieDialog;
